import React from 'react';
import Helmet from 'react-helmet';

const MetaTags = ({
  title = 'Offer Raffle House | Win Your Dream Home',
  description = '',
  keywords = [''],
  canonical = process.env.REACT_APP_BASE_URL_LANDING,
}) => {
  return (
    <Helmet
      meta={[
        {
          name: 'description',
          content: description,
        },
        {
          name: 'keywords',
          content: keywords.join(),
        },
      ]}
      link={[
        {
          rel: 'canonical',
          href: canonical,
        },
      ]}
      title={title}
    >
      {process.env.REACT_APP_BASE_URL_LANDING ===
        'https://offer-staging.rafflehouse.com' && (
        <meta name='robots' content='noindex' />
      )}
    </Helmet>
  );
};

export default MetaTags;
